import { createStructuredSelector } from "reselect";

import { DEFAULT_SIGNUP_REQUIRED } from "./constants";

import { getUserDetailSelector, getUserErrorSelector, UserState } from "../../ducks/user";
import { getPortalConfigSelector } from "../../ducks/portalConfig";

import { RootState } from "../../ducks/reducers";

const structuredSelectors = createStructuredSelector<
  RootState,
  Pick<UserState, "error"> & { detail?: string; required?: Record<string, boolean> }
>({
  error: getUserErrorSelector,
  detail: getUserDetailSelector,
  required: (state: RootState) =>
    getPortalConfigSelector(state)?.settings?.regForm?.required || DEFAULT_SIGNUP_REQUIRED,
});

export default structuredSelectors;
